/** Based on Mass PFML: https://github.com/navapbc/archive-massgov-pfml/blob/main/portal/src/components/core/Icon.tsx */

import classnames from 'classnames';

import React from 'react';

export interface IconProps {
  /** Name of the the USWDS Icon to render */
  name: string;
  className?: string;
  fill?: string;
  size?: number;
}
/**
 * SVG icon from the U.S. Web Design System
 * [USWDS Reference ↗](https://designsystem.digital.gov/components/icons/)
 */
function Icon(props: IconProps) {
  const usaIconClass = typeof props.size === 'number' ? `usa-icon usa-icon--size-${props.size}` : 'usa-icon';
  const className = classnames(usaIconClass, props.className);

  return (
    <svg className={className} aria-hidden="true" focusable="false" role="img" fill={props.fill}>
      <use xlinkHref={`${process.env.NEXT_PUBLIC_BASE_PATH}/uswds/img/sprite.svg#${props.name}`} />
    </svg>
  );
}

export default Icon;
